/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The information related to the result page.
 */

// required attributes
const PageInfoR = t.interface({
  items_found: t.Integer,

  limit: t.Integer,

  page: t.Integer,

  total_items: t.Integer,

  total_pages: t.Integer
});

// optional attributes
const PageInfoO = t.partial({});

export const PageInfo = t.intersection([PageInfoR, PageInfoO], "PageInfo");

export type PageInfo = t.TypeOf<typeof PageInfo>;
